module.exports = __webpack_public_path__ + "media/SAF-700_Ares_SocialEngineeringRedFlags_2025.69a77368.mp4";